import type { AnyFieldApi } from "@tanstack/react-form";

/**
 * Form-level `listeners` for `useAppForm`: calls `onChangeForm` once per field change (typing, picking,
 * `setValue` from the handle), never on mount. Without a callback it returns no listeners at all.
 */
export const changeListeners = (onChangeForm?: () => void): { onChange?: () => void } =>
  onChangeForm ? { onChange: () => onChangeForm() } : {};

/**
 * Form-level `listeners.onBlur` that re-runs the form's one schema on the blurred field, so focusing and
 * leaving an untouched empty field reveals its error (the visibility gate still decides what shows). It
 * runs the same `onChange` validator source, so a field never gets a second error, and a later valid
 * change clears it live. Spread it next to `changeListeners` when a form needs both.
 */
export const blurValidationListeners = (): { onBlur: (props: { fieldApi: AnyFieldApi }) => void } => ({
  onBlur: ({ fieldApi }) => {
    void fieldApi.validate("change");
  },
});
